
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo/dock",
      function () {
        return require("private-next-pages/demo/dock.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo/dock"])
      });
    }
  